import { z } from 'zod';
import { paginationFiltersSchema } from 'utils/schemas';

export const adminShopVouchersFiltersSchema = z
  .object({
    search: z.string().catch(''),
  })
  .merge(paginationFiltersSchema);
